/** Render-only dressing, relative to each toilet's front edge and centre. */
export const RESTROOMS = {
  floorOffset: 0.003,
  sleeper: {
    toilet: 'wc-pontto-3',
    lid: 'wc-kansi-3',
    height: 1.76,
    seed: 700,
    slump: 0.3,
    headDrop: 0.55,
    headTilt: 0.14,
  },
  urine: { color: 0xc6a52c, opacity: 0.58, shininess: 95 },
  puddles: [
    { x: 0.43, z: 0.04, radiusX: 0.48, radiusZ: 0.28 },
    { x: 1.04, z: -0.13, radiusX: 0.17, radiusZ: 0.12 },
    { x: 0.83, z: 0.25, radiusX: 0.07, radiusZ: 0.055 },
  ],
  paper: {
    toilets: ['wc-pontto-1', 'wc-pontto-2'],
    color: 0xf3efdf,
    coreColor: 0x998065,
    x: 0.02,
    z: -0.35,
    radius: 0.06,
    coreRadius: 0.022,
    width: 0.105,
    length: 0.62,
    foldHeight: 0.022,
  },
} as const;
